"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * VideoCell - Composant vidéo responsive
 * 
 * @param {Object} props
 * @param {string} props.video_uri - URL de la vidéo
 * @param {boolean} [props.loop=false] - Boucle la vidéo
 * @param {boolean} [props.autoplay=false] - Lecture automatique
 * @param {boolean} [props.muted=true] - Vidéo muette (requis pour autoplay)
 * @param {boolean} [props.controls=true] - Afficher les contrôles
 * @param {Object} [props.styles_properties] - Propriétés de style
 * @param {string} [props.className] - Classes CSS additionnelles
 * @param {Object} [props.style] - Styles inline additionnels
 * @param {string} [props.poster] - Image d'aperçu
 * @param {'cover' | 'contain' | 'fill'} [props.objectFit='cover'] - Mode d'ajustement
 * @param {Function} [props.onPlay] - Callback quand la vidéo démarre
 * @param {Function} [props.onPause] - Callback quand la vidéo est en pause
 * @param {Function} [props.onEnded] - Callback quand la vidéo se termine
 */const VideoCell = ({
  video_uri,
  loop = false,
  autoplay = false,
  muted = true,
  controls = true,
  styles_properties = {},
  className = '',
  style = {},
  poster,
  objectFit = 'cover',
  onPlay,
  onPause,
  onEnded,
  uri_transformer = url => url,
  ...rest
}) => {
  const videoRef = (0, _react.useRef)(null);

  // Gérer l'autoplay (nécessite muted pour fonctionner)
  (0, _react.useEffect)(() => {
    if (autoplay && videoRef.current) {
      // Autoplay avec muted pour respecter les politiques des navigateurs
      videoRef.current.muted = true;
      videoRef.current.play().catch(() => {
        // Silently fail if autoplay is blocked
      });
    }
  }, [autoplay]);

  // Styles du conteneur
  const containerStyle = {
    backgroundColor: styles_properties.background_color,
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius}px` : undefined,
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width}px` : undefined,
    borderStyle: styles_properties.border_style,
    padding: styles_properties.padding ? `${styles_properties.padding}px` : undefined,
    opacity: styles_properties.opacity,
    overflow: 'hidden',
    ...style
  };

  // Classes pour l'objectFit
  const videoClasses = ['video-cell__video', objectFit === 'contain' && 'video-cell__video--contain'].filter(Boolean).join(' ');
  const containerClasses = ['video-cell', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: containerClasses,
    style: {
      ...containerStyle,
      height: '100%',
      width: '100%'
    },
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("video", {
      ref: videoRef,
      className: videoClasses,
      src: uri_transformer(video_uri),
      loop: loop,
      muted: muted,
      controls: controls,
      poster: poster,
      playsInline: true,
      onPlay: onPlay,
      onPause: onPause,
      onEnded: onEnded,
      style: {
        objectFit,
        height: '100%',
        width: '100%'
      },
      children: "Votre navigateur ne supporte pas la lecture de vid\xE9os."
    })
  });
};
var _default = exports.default = VideoCell;